import { ImageType } from "@/types/baseTypes";
import { PostsGridElementType } from "../components/PostCard/PostCard";
import { WPClient } from "../wp/client/WPClient";
import { PostsGridModuleType } from "../modules/PostGrid/PostGrid";

/* jscpd:ignore-start */
interface FetchPostsProps {
  page: number;
  postsPerPage: number;
  offset: number;
  locale: string | undefined;
  defaultLocale: string | undefined;
  module: PostsGridModuleType;
  fallback_options: "header-img" | "teaser-text";
  fallback_image?: ImageType | false;
  abortController?: AbortController;
}
/* jscpd:ignore-end */

export const fetchPosts = async ({
  module,
  page,
  postsPerPage,
  offset,
  locale,
  defaultLocale,
  fallback_options,
  fallback_image,
  abortController,
}: FetchPostsProps) => {
  const client = new WPClient({ locale, defaultLocale });

  const { type, categories, posts: selectedPosts } = module.grid;

  const postsResult = await client.getPosts({
    type: "blog",
    page: page,
    perPage: postsPerPage,
    offset,
    fields: [
      "id",
      "date",
      "date_gmt",
      "modified_gmt",
      "_embedded",
      "acf.header_post",
      "link",
      "categories",
    ],
    ...(type === "posts" && {
      includeIds: { ids: selectedPosts || [], keepOrder: true },
    }),
    ...(type === "categories" && {
      includeCategories: [{ category: "categories", ids: categories || [] }],
    }),
    abortController,
  });

  const posts = postsResult.posts.map((post) => {
    const header = post.acf?.header_post;
    const _categories = post._embedded?.["wp:term"]
      ? post._embedded["wp:term"][0]
      : [];

    return {
      id: post.id,
      date: post.date || post.date_gmt || post.modified_gmt,
      title: header?.title || "",
      image:
        header?.image ||
        (fallback_options === "header-img"
          ? header.media.image_desktop
            ? header.media.image_desktop
            : fallback_image
              ? fallback_image
              : false
          : false),
      excerpt: header?.excerpt || "",
      link: post.link,
      categories: _categories ? _categories : [],
    } as PostsGridElementType;
  });

  return {
    posts,
    totalPosts: postsResult.totalPosts,
  };
};
